import React from 'react';

import Link from '../../../../library/link/link';
import TagsSolidIcon from '../../../../shared/icons/tags-solid-icon';

import './product-link-deals-header.scss';

interface DealsHeaderProps {
  category: {
    catalogURL: string;
    name: string;
  };
  onClick(): void;
}

export default function ProductLinkDealsHeader(props: DealsHeaderProps) {
  const { category, onClick } = props;
  const { catalogURL, name } = category || {};

  return (
    <div className="deals-header" styleName="container">
      <TagsSolidIcon styleName="promo" />
      <span>Deals</span>
      <Link
        onClick={onClick}
        styleName="link-text"
        to={`${catalogURL}&q=%3Aonpromotion-asc%3AinstantSavings-boolean%3AInstant%20Savings%3Arebates-boolean%3ARebates%3AspecialOffers-boolean%3ASpecial%20Offers`}
      >
        {`shop ${name?.toLowerCase()} deals`}
      </Link>
    </div>
  );
}
